import React from 'react';
import { Colors as C } from '../../constants/Colors.js';
import { MP_SURF } from '../constants/surfaces.js';
import MarketplaceFiltersSidebar from './MarketplaceFiltersSidebar.js';

const drawerBtnBase = {
  borderRadius: 8,
  padding: '6px 12px',
  fontSize: '0.78rem',
  fontWeight: 700,
  cursor: 'pointer',
  fontFamily: 'inherit',
  whiteSpace: 'nowrap',
};

/**
 * Panel lateral de búsqueda y filtros (Mercado y Subastas).
 * Cabecera fija con Limpiar filtros + Cerrar; el contenido hace scroll debajo.
 */
export default function MarketplaceFiltersDrawerPanel({
  open,
  onClose,
  onClearFilters,
  topPx,
  filters,
  actions,
  tooltipCond,
  setTooltipCond,
  maxSavedFilters = 5,
  filterSlotPurchase = null,
}) {
  if (!open) return null;

  return (
    <>
      <div
        role="presentation"
        aria-hidden="true"
        onClick={onClose}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          top: topPx,
          background: 'rgba(0,0,0,0.38)',
          zIndex: 220,
        }}
      />
      <aside
        data-guest-safe
        role="dialog"
        aria-modal="true"
        aria-label="Buscar y filtros"
        style={{
          position: 'fixed',
          top: topPx,
          left: 0,
          bottom: 0,
          width: 'min(400px, 94vw)',
          background: MP_SURF.drawerBg,
          zIndex: 230,
          boxShadow: '6px 0 28px rgba(0,0,0,0.45)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <header
          style={{
            flexShrink: 0,
            zIndex: 2,
            padding: '12px 14px',
            borderBottom: `1px solid ${MP_SURF.divider}`,
            background: MP_SURF.drawerBg,
            boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span
              style={{
                flex: '1 1 auto',
                minWidth: 120,
                fontWeight: 800,
                fontSize: '0.88rem',
                color: C.gold,
                letterSpacing: '0.02em',
              }}
            >
              Buscar y filtros
            </span>
            <button
              type="button"
              data-guest-safe
              onClick={() => onClearFilters?.()}
              style={{
                ...drawerBtnBase,
                background: 'rgba(200,168,75,0.08)',
                border: '1px solid rgba(200,168,75,0.35)',
                color: C.gold,
              }}
            >
              Limpiar filtros
            </button>
            <button
              type="button"
              data-guest-safe
              onClick={onClose}
              style={{
                ...drawerBtnBase,
                background: 'rgba(200,168,75,0.12)',
                border: '1px solid rgba(200,168,75,0.4)',
                color: C.gold,
              }}
            >
              Cerrar
            </button>
          </div>
        </header>
        <div
          className="dv-scrollbar"
          style={{
            flex: '1 1 auto',
            minHeight: 0,
            overflowY: 'auto',
            padding: 12,
          }}
        >
          <MarketplaceFiltersSidebar
            filters={filters}
            actions={actions}
            tooltipCond={tooltipCond}
            setTooltipCond={setTooltipCond}
            embeddedInDrawer
            maxSavedFilters={maxSavedFilters}
            filterSlotPurchase={filterSlotPurchase}
          />
        </div>
      </aside>
    </>
  );
}
